var Achievements = {
	linkUrl: {
		"setup_guide": "/guide",
		"companionship": "/invitations",
		"companionship_create": "/admin/createaccounts",
		"companionship_create2": "/invitations",
		"create_job": "/job#new",
		"schedule_self": "/jobs#all",
		"report_work": "/reports/report",
		"report_work2": Core.client && Core.client.hasPermission('view_jobs') ? "/jobs#mine" : undefined,
		"invoicing": "/invoice",
		"finish_invoicing": "/invoice",
		"create_customer": "/admin/customers#new",
		"create_job_template": "/job?template#new",
		"create_report_template": "/reports/report#new-template",
		"leave_example_group": "/admin/group#example"
	},
	
	fadeInAchievementAlerts: function(root) {
		if (!root)
			root = 'body';
		$(root).find('.achievement-alert').each(function () {
			Achievements.fadeInIfNotAchieved($(this).attr('data-achievement'), this);
		});
	},

	fadeInIfNotAchieved: function(achievement, el) {
		Achievements.ifNotAchieved(achievement, function() { $(el).fadeIn(); });
	},

	ifNotAchieved: function(achievement, callback) {
		$.getJSON((Core.contextRoot + '/achievement/' + achievement + '/verify'), function(data, status, response) {
			// Server responds 204 (No Content) if not achieved
			if (response.status == 204) {
				sessionStorage['achievement_' + achievement + '_achieved'] = false;
				callback();
			}
		});
	}

};
